import React from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import Stepper from "react-stepper-horizontal";
import {
  pasos_post,
  GetVideoRespuestasCandidato,
  DesVideoRespTecnicas,
} from "../requests/req_postulaciones";
import Modalform from "../components/Modalform";
import { List, ListItem } from "react-md";
import { notifica } from "../requests/utils";
import "../styles/modal.css";
import Loader from "react-loader-spinner";

export default class CardPostulacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      moduloModal: null,
      idSolicitud: 0,
      idSolicitudA: 0,
      vrespuestas: [],
      vmresp: false,
      videoResp: "#",
      iconvresp: process.env.PUBLIC_URL + "/images/icon_video.png",
      icondelresv: process.env.PUBLIC_URL + "/images/icon_delete.png",
      isLoading: false,
    };
    this.generaLista = this.generaLista.bind(this);
    this.abreEncuestas = this.abreEncuestas.bind(this);
    this.getVideoRespuestas = this.getVideoRespuestas.bind(this);
    this.deshabilitarRespuestas = this.deshabilitarRespuestas.bind(this);
    this.getRespAxios = this.getRespAxios.bind(this);
    this.resetCardsPost = this.resetCardsPost.bind(this);
  }
  componentDidMount() {
    const { data } = this.props;

    var js = { idSolicitud: data.idSolicitud };
    GetVideoRespuestasCandidato(js, (x) => this.getVideoRespuestas(x));
  }
  resetCardsPost() {
    const { data } = this.props;

    var js = { idSolicitud: data.idSolicitud };
    GetVideoRespuestasCandidato(js, (x) => this.getVideoRespuestas(x));
  }
  deshabilitarRespuestas(idPregunta, idPreguntasTecnicas) {
    this.setState({ isLoading: true });
    const { data } = this.props;
    var js = { idSolicitud: data.idSolicitud, idPregunta, idPreguntasTecnicas };

    DesVideoRespTecnicas(js, (x) => this.getRespAxios(js, x));
  }
  getRespAxios(js, datos) {
    if (datos != null) {
      const { code, message } = datos;
      if (code === 0) {
        const { idPregunta } = js;
        var val = true;
        var arr = [];
        arr = this.state.vrespuestas.filter(
          (x) => parseInt(x.idPregunta) !== parseInt(idPregunta)
        );
        if (arr.length === 0) val = false;
        this.setState({ vrespuestas: arr, videoResp: "#", vmresp: val });
        notifica("success", message, "ok");
        this.setState({ isLoading: false });
        this.props.reset();
      } else {
        this.setState({ isLoading: false });
        notifica("warning", message, "Error en la consulta!");
      }
    } else {
      this.setState({ isLoading: false });
    }
  }
  vacante = (e) => {
    var elm = e.target,
      idV = elm.getAttribute("idvacante"),
      i = parseInt(idV, 10);
    this.props.action(i);
  };

  getVideoRespuestas(datos) {
    if (datos != null) {
      const { code, data } = datos;
      if (code === 0) {
        if (Array.isArray(data)) {
          this.setState({ vrespuestas: data });
        }
      }
    }
  }

  generaLista(pro) {
    //this.setState({ idSolicitud: pro.idSolicitud })

    return pro.progreso.map((a, index) => {
      var imgn = process.env.PUBLIC_URL + "/images/" + a.icono + ".png";
      if (a.nombre === "Grabar Preguntas Tecnicas") {
        return (
          <ListItem
            id={pro.idSolicitud}
            key={index}
            primaryText={a.nombre}
            secondaryText={a.fecha}
            leftAddon={<img src={imgn} class="img_icon" alt="img" />}
            leftAddonType="media"
            onClick={(e) => this.abreEncuestas(e)}
          />
        );
      } else {
        return null;
      }
    });
  }
  abreEncuestas = (e) => {
    this.setState({ idSolicitudA: e.currentTarget.id }, () =>
      document.getElementById("BtnMdl").click()
    );
  };
  render() {
    var a = this.props.data.progreso.length - 1,
      {
        idSolicitudA,
        vrespuestas,
        vmresp,
        videoResp,
        iconvresp,
        icondelresv,
        isLoading,
      } = this.state;
    return (
      <Col
        xm={12}
        sm={6}
        md={6}
        lg={4}
        xl={3}
        className="Crd_Pstl"
        id={this.props.data.idSolicitud}
      >
        <div
          style={{ backgroundColor: "#8E8F8F", borderRadius: "20px" }}
          className="DV_Pstl"
        >
          <label
            style={{
              color: "white",
              fontWeight: "bold",
              wordBreak: "break-word",
            }}
            className="lbl_bg"
          >
            {this.props.data.tituloVacante}
          </label>
          <br />
          {/* <label style={{color:'white'}} className="lbl_md">Triplei</label> */}
          {/* <label style={{color:'white'}} className="lbl_md">{this.props.data.empresa !== ""?this.props.data.empresa:'Triplei'}</label>
            <br /> */}
          <label style={{ color: "white" }} className="lbl_sm">
            {this.props.data.lugar}
          </label>
          <br />

          <Stepper
            completeColor={"#F08080"}
            steps={pasos_post}
            activeStep={a}
            activeColor={"#F08080"}
            circleFontColor={"#000000"}
            defaultColor={"#B3B6B7"}
            activeTitleColor={"#FDFEFE "}
          />
          {this.props.data.progreso.length === 3 ? (
            <Button
              className="btn_fullwidth"
              disabled={true}
              style={{
                backgroundColor: "#F08080",
                color: "black",
                fontWeight: "bold",
              }}
            >
              Vacante cerrada
            </Button>
          ) : (
            <Button
              className="btn_fullwidth"
              style={{
                backgroundColor: "#F08080",
                color: "black",
                fontWeight: "bold",
              }}
              idvacante={this.props.data.idSolicitud}
              onClick={(e) => this.vacante(e)}
            >
              Ver Vacante
            </Button>
          )}

          <div className="lg-grid">
            <List
              className="lg-cell lg-cell--6 lg-paper lg-paper--1"
              style={{
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
                padding: 0,
                backgroundColor: "white",
              }}
            >
              {this.generaLista(this.props.data)}
            </List>
          </div>
        </div>
        {idSolicitudA > 0 ? (
          <Modalform
            modulo={"Preguntas Técnicas"}
            idSolicitud={idSolicitudA}
            btnsv={null}
            cerrar={() => this.setState({ idSolicitudA: 0 })}
          />
        ) : null}

        <Modal
          isOpen={vmresp}
          className="App-Mod"
          id="ModivRespV"
        >
          <ModalHeader className="App-Mod-Hedr">
            <div className="Mod_Hdr_ttl">
              <label id="lbl_mdlv">Video Respuestas</label>
              <div className="Hide_Half" id="md_ldrv"></div>
            </div>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col
                xm={4}
                sm={4}
                md={4}
                lg={4}
                xl={4}
                style={{ overflow: "auto", maxHeight: "400px" }}
              >
                {isLoading ? (
                  <Loader
                    visible={isLoading}
                    type="Watch"
                    color="#F5A796"
                    height="150"
                    width="150"
                  />
                ) : (
                  vrespuestas.map((item, Index) => {
                    const {
                      pregunta,
                      videoRespuesta,
                      idPreguntasTecnicas,
                      idPregunta,
                    } = item;

                    return (
                      <FormGroup>
                        <Col xm={12} sm={12} md={12} lg={12} xl={12}>
                          {pregunta}
                        </Col>
                        <Col xm={12} sm={12} md={12} lg={12} xl={12}>
                          {
                            <a
                              href="/"
                              onClick={(e) =>
                                this.setState({ videoResp: videoRespuesta })
                              }
                              data-toggle="tooltip"
                              title="Ver video"
                            >
                              <img
                                src={iconvresp}
                                className="img_icon"
                                alt="Ver Video"
                              />
                            </a>
                          }
                          {
                            <a
                              href="/"
                              onClick={(e) =>
                                this.deshabilitarRespuestas(
                                  idPregunta,
                                  idPreguntasTecnicas
                                )
                              }
                              data-toggle="tooltip"
                              title="Eliminar video"
                            >
                              <img
                                src={icondelresv}
                                className="img_icon"
                                alt="Eliminar video"
                              />
                            </a>
                          }
                        </Col>
                      </FormGroup>
                    );
                  })
                )}
              </Col>

              <Col
                xm={8}
                sm={8}
                md={8}
                lg={8}
                xl={8}
                style={{ maxHeight: "400px" }}
              >
                {videoResp === "#" ? (
                  <center>
                    <Loader
                      visible={videoResp === "#"}
                      type="Watch"
                      color="#F5A796"
                      height="390"
                      width="100%"
                    />
                  </center>
                ) : (
                  <center>
                    <video
                      src={videoResp}
                      autoplay
                      controls
                      width="100%"
                      style={{ maxHeight: "390px" }}
                    ></video>
                  </center>
                )}
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              onClick={() => this.setState({ vmresp: false, videoResp: "#" })}
              id="cncmdlv"
              className="btn_mod_fot"
            >
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>

        <button
          id={"btnresetPostCard" + this.props.data.idSolicitud}
          type="button"
          hidden={true}
          onClick={(e) => this.resetCardsPost()}
        ></button>
      </Col>
    );
  }
}
